export default function LabelItem({label, children}) {
  return (
    <li className="list__item--order-data list__item--shipping-info">
      <strong className="margin-right-3">{label}:</strong>
      {children ? <span>{children}</span> : <em>None selected</em>}
    </li>
  )
}
